<template src="./template.html"></template>
<style lang="scss" src="./styles.scss"></style>

<script>
import { mapActions, mapState } from 'vuex'
import FallbackAvatar from '@/components/ui/FallbackAvatar'
import LanguageSwitcher from '@/components/ui/LanguageChanger'
import NavigationItem from '@/components/navigation/NavigationItem'
import ConfirmationOverlay from '@/components/overlays/ConfirmationOverlay'
import api from '@/api'

export default {
  name: 'AppNavigation',
  components: {
    FallbackAvatar,
    LanguageSwitcher,
    NavigationItem,
    ConfirmationOverlay,
  },
  props: {
    activityBgColor: {
      type: String,
      default: 'accent',
    },
    appendSearch: Boolean,
    navigationBgColor: {
      type: String,
      default: 'main-lighten-5',
    },
    prependSearch: Boolean,
    routes: Array,
    settingsRoutes: Array,
    showLanguageSwitcher: Boolean,
    user: Object,
    value: Boolean,
    right: {
      type: Boolean,
      default: true,
    },
    advancedSearchType: String,
  },
  data() {
    return {
      open: false,
      search: null,
      isSettingsMenu: false,
      getConsent: false,
      toggleActionUrl: null,
      pages: {},
    }
  },
  computed: {
    ...mapState('activities', [ 'unread_activities' ]),
    ...mapState('auth', [
      'location',
      'settings',
      'consent_accepted',
    ]),
    ...mapState('pages', [ 'legal_pages' ]),
    links() {
      const links = []
      if (process.env.NODE_ENV === 'development') {
        links.push({ title: 'Dummy', icon: this.iconMapping('dummy'), type: 'dummy' })
      }
      return links
    },
    getLogo() {
      const logo =
        this.settings &&
        this.settings.base_options &&
        this.settings.base_options.show_company_logo &&
        this.location &&
        this.location.image
          ? this.location.image
          : this.customerConfig.images.logo
      return logo
    },
  },
  watch: {
    value: {
      handler() {
        this.open = this.value
        this.isSettingsMenu = false
      },
      immediate: true,
    },
    open() {
      this.$emit('input', this.open)
    },
  },
  created() {
    if (this.user) {
      this.getCountUnreadActivities()
    }
  },
  mounted() {
    this.getLegalPages().then(_ => {
      this.setPages()
    })
  },
  methods: {
    ...mapActions('activities', [ 'getCountUnreadActivities' ]),
    ...mapActions('auth', [ 'getSettingsMenu' ]),
    ...mapActions('pages', [ 'getLegalPages' ]),
    onSearch() {
      if (!this.search) return false

      if (this.$route.name === 'search-results' && this.$route.query.q !== this.search) {
        this.$router.push({ query: { q: this.search } })
      } else if (this.$route.query.q !== this.search) {
        this.$router.push({ name: 'search-results', query: { q: this.search } })
      }

      this.search = null
    },
    toggleAction(url, status, force = false) {
      this.toggleActionUrl = url
      if (!status && !this.consent_accepted && !force) {
        this.getConsent = true
      } else {
        this.closeOverlay()
        api.items.editItem(url).then(_ => {
          this.getSettingsMenu()
        })
      }
    },
    getConsentOverlayObject(pages) {
      return {
        title: this.$t('login.toggle_consent.title'),
        text: this.$t('login.toggle_consent.text', pages),
        button_text: this.$t('login.toggle_consent.button_text'),
        checkbox: true,
      }
    },
    toggleActionConfirm() {
      api.items.editItem('auth.accept_consent').then(_ => {
        this.toggleAction(this.toggleActionUrl, false, true)
        this.getSettingsMenu()
      })
    },
    closeOverlay() {
      this.getConsent = false
      this.toggleActionUrl = null
    },
    setPages() {
      Object.entries(this.legal_pages).forEach(page => {
        this.pages[page[0]] = this.$router.resolve({ name: 'page', params: { id: page[1].page_id } }).href || ''
      })
    },
  },
}
</script>
